export default "__VITE_ASSET__DrQRQO2i__"